import { useT } from '@transifex/react';

import { formatBirthdayForDisplay } from '#modules/localization';
import { TextField } from '#modules/ui/TextField';

export type DateFieldProps = {
  value: string;
  error: string | null;
  onChangeText: (text: string) => void;
  onBlur: () => void;
  testID?: string;
};

/** A `date` question's masked MM / DD / YYYY input. */
export function DateField({ value, error, onChangeText, onBlur, testID }: DateFieldProps) {
  const t = useT();
  return (
    <TextField
      value={value}
      onChangeText={onChangeText}
      onBlur={onBlur}
      format={formatBirthdayForDisplay}
      placeholder={t('MM / DD / YYYY')}
      inputMode='numeric'
      keyboardType='number-pad'
      errorMessage={error ?? undefined}
      testID={testID}
    />
  );
}
